(() => {
  function getSwiperCtor() {
    if (typeof Swiper !== 'undefined') return Swiper;
    if (window.Swiper && window.Swiper.default) return window.Swiper.default;
    return null;
  }

  function init(root = document) {
    const SwiperCtor = getSwiperCtor();
    if (!SwiperCtor) return false;

    const sectionEls = root.querySelectorAll('.general-slideshow-section');
    if (!sectionEls.length) return true;

    sectionEls.forEach((sectionEl) => {
      if (sectionEl.dataset.swiperInitialized) return;
      sectionEl.dataset.swiperInitialized = 'true';

      const rightEl = sectionEl.querySelector('.general-slideshow-right-slider');
      const leftEl = sectionEl.querySelector('.general-slideshow-left-slider');
      if (!rightEl || !leftEl) return;

      const generalslidershowright = new SwiperCtor(rightEl, {
        loop: true,
        spaceBetween: 0,
        slidesPerView: 1,
        freeMode: false,
        watchSlidesVisibility: true,
        watchSlidesProgress: true,
        slideToClickedSlide: true,
      });

      const generalslidershowleft = new SwiperCtor(leftEl, {
        loop: true,
        spaceBetween: 0,
        watchSlidesProgress: true,
        navigation: {
          nextEl: sectionEl.querySelector('.general-slideshow-icon-arrow-next'),
          prevEl: sectionEl.querySelector('.general-slideshow-icon-arrow-prev'),
        },
        pagination: {
          el: sectionEl.querySelector('.swiper-pagination-general-slideshow'),
          clickable: true,
        },
        breakpoints: {
          992: {
            pagination: {
              enabled: false,
            },
          },
        },
      });

      generalslidershowright.controller.control = generalslidershowleft;
      generalslidershowleft.controller.control = generalslidershowright;

      function setSectionBgFromActive() {
        const activeSlide = generalslidershowleft.slides[generalslidershowleft.activeIndex];
        if (!activeSlide) return;
        const color = activeSlide.getAttribute('data-slide-bg-color') || activeSlide.dataset.slideBgColor;
        if (!color) return;
        const wrapper = sectionEl.closest('.shopify-section') || sectionEl.parentElement;
        if (wrapper) {
          wrapper.style.setProperty('--slide-bg-color', color);
        }
      }

      setSectionBgFromActive();
      generalslidershowleft.on('slideChange', setSectionBgFromActive);
    });

    return true;
  }

  function waitForSwiper(attempt = 0) {
    if (init()) return;
    if (attempt >= 50) return;
    setTimeout(() => waitForSwiper(attempt + 1), 100);
  }

  waitForSwiper();

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      waitForSwiper(0);
      init(event.target);
    });
  }
})();
